import { apiClient } from "./apiClient";
import { API_ENDPOINTS } from "../constants";

export const chatbotNotificationService = {
    /* ---------- Departments ---------- */

    async listDepartments(chatbotId: string) {
        const res = await apiClient.get(
            API_ENDPOINTS.CHATBOT_NOTIFICATIONS.DEPARTMENTS(chatbotId),
            { authenticate: true }
        );
        return (res as any)?.data ?? res;
    },

    async createDepartment(payload: any) {
        const res = await apiClient.post(
            API_ENDPOINTS.CHATBOT_NOTIFICATIONS.CREATE_DEPARTMENT,
            payload,
            { authenticate: true }
        );
        return (res as any)?.data ?? res;
    },

    async updateDepartment(id: string, payload: any) {
        return apiClient.patch(
            API_ENDPOINTS.CHATBOT_NOTIFICATIONS.UPDATE_DEPARTMENT(id),
            payload,
            { authenticate: true }
        );
    },

    /* ---------- Staff ---------- */

    async listStaff(chatbotId: string) {
        const res = await apiClient.get(
            API_ENDPOINTS.CHATBOT_NOTIFICATIONS.STAFF(chatbotId),
            { authenticate: true }
        );
        return (res as any)?.data ?? res;
    },

    async createStaff(payload: any) {
        const res = await apiClient.post(
            API_ENDPOINTS.CHATBOT_NOTIFICATIONS.CREATE_STAFF,
            payload,
            { authenticate: true }
        );
        return (res as any)?.data ?? res;
    },

    async updateStaff(id: string, payload: any) {
        return apiClient.patch(
            API_ENDPOINTS.CHATBOT_NOTIFICATIONS.UPDATE_STAFF(id),
            payload,
            { authenticate: true }
        );
    },
};
